import { MapPin, Calendar, Users, Star, ArrowRight, Bus } from "lucide-react";
import Reveal from "@/components/Reveal";

const excursions = [
  {
    id: "balcic-kaliakra",
    title: "Balcic + Cap Kaliakra",
    duration: "1 zi",
    price: "159 RON / pers",
    departure: "Sâmbăta 07:00",
    highlights: [
      "Cetatea și faleza Cap Kaliakra",
      "Palatul Reginei Maria & Grădina Botanică Balcic",
      "Promenadă și port + timp liber",
      "Opriri în 2 Mai și Vama Veche",
    ],
    tag: "1 zi",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0b/BG_TX_Balchik_queen_Maria_castle_1.jpg/1280px-BG_TX_Balchik_queen_Maria_castle_1.jpg",
  },
  {
    id: "histria-jurilovca-enisala",
    title: "Histria – Jurilovca – Enisala",
    duration: "1 zi",
    price: "179 RON / pers",
    departure: "Sâmbăta 07:00",
    highlights: [
      "Cetatea Histria (muzeu + ghid)",
      "Portul turistic Jurilovca",
      "Capul Doloșman / Argamum",
      "Cetatea Enisala + oprire Babadag",
    ],
    tag: "1 zi",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Ruins_of_Histria_%28AP4E5712_1PS%29_%2828340359564%29.jpg/1280px-Ruins_of_Histria_%28AP4E5712_1PS%29_%2828340359564%29.jpg",
  },
  {
    id: "adamclisi-sf-andrei-dervent",
    title: "Adamclisi – Sf. Andrei – Dervent",
    duration: "1 zi",
    price: "169 RON / pers",
    departure: "Sâmbăta 07:00",
    highlights: [
      "Tropaeum Traiani – monument și muzeu",
      "Mănăstirea și Peștera Sf. Andrei",
      "Mănăstirea Dervent",
      "Fotografii la Dunăre",
    ],
    tag: "Istorie",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/006_MG_6430_Tropaeum_Traiani_Adamclisi_006.jpg/1280px-006_MG_6430_Tropaeum_Traiani_Adamclisi_006.jpg",
  },
  {
    id: "murighiol-delta-dunarii",
    title: "Murighiol – Delta Dunării",
    duration: "1 zi",
    price: "199 RON / pers",
    departure: "Sâmbăta 07:00",
    highlights: [
      "Deplasare cu microbuzul până în Delta",
      "Plimbare opțională cu barca (plată separată)",
      "Timp liber pentru masă & fotografii",
      "Peisaje unice de deltă",
    ],
    tag: "Natură",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8b/White_pelicans_%28Pelecanus_onocrotalus%29_Danube_delta.jpg/1280px-White_pelicans_%28Pelecanus_onocrotalus%29_Danube_delta.jpg",
  },
  {
    id: "istanbul",
    title: "Istanbul – Perla Bosforului",
    duration: "4 zile / 3 nopți",
    price: "125 EUR / pers",
    departure: "Joi seara",
    highlights: [
      "Moscheea Albastră & Hagia Sophia",
      "Bazarul Mare & Bazarul Egiptean",
      "Croazieră pe Bosfor",
      "Cazare hotel 3★ inclus (3 nopți)",
    ],
    tag: "Popular",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Sultanahmet_ferry_on_the_Bosphorus_in_Istanbul%2C_Turkey_001.jpg/1280px-Sultanahmet_ferry_on_the_Bosphorus_in_Istanbul%2C_Turkey_001.jpg",
  },
];

export default function Excursii() {
  const handleReserve = (title) => {
    const destInput = document.querySelector('[data-testid="booking-input-destinatie"]');
    if (destInput) {
      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
        window.HTMLInputElement.prototype,
        "value"
      ).set;
      nativeInputValueSetter.call(destInput, `Excursie: ${title}`);
      destInput.dispatchEvent(new Event("input", { bubbles: true }));
    }
    document.querySelector("#rezervare")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="excursii"
      data-testid="excursions-section"
      className="py-20 lg:py-28 bg-slate-950"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <span className="text-amber-500 font-semibold text-sm uppercase tracking-widest">
              Excursii
            </span>
            <h2
              data-testid="excursii-title"
              className="mt-3 text-3xl lg:text-4xl font-bold text-white max-w-2xl"
            >
              Descoperă locuri noi cu plecări din Mangalia.
            </h2>
            <p className="mt-4 text-slate-300 max-w-xl">
              Călătorii ghidate cu <strong className="text-white">Mercedes Sprinter 2026</strong>{" "}
              — microbuze noi de <strong className="text-white">19 locuri</strong>, aer condiționat,
              scaune confortabile, WiFi.
            </p>
          </div>
          <div className="flex items-center gap-3 bg-slate-900 border border-slate-800 rounded-2xl px-5 py-4">
            <div className="w-12 h-12 rounded-xl bg-amber-500 text-slate-950 flex items-center justify-center">
              <Bus className="w-6 h-6" strokeWidth={2.2} />
            </div>
            <div>
              <div className="font-semibold text-white text-sm">Mercedes Sprinter 2026</div>
              <div className="text-xs text-slate-400">19 locuri · A/C · WiFi</div>
            </div>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {excursions.map((ex, i) => (
            <Reveal key={ex.id} delay={i * 80}>
              <article
                data-testid={`excursion-card-${ex.id}`}
                className="group relative h-full bg-slate-900 border border-slate-800 hover:border-amber-500/60 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl flex flex-col"
              >
                <div className="relative aspect-[16/10] overflow-hidden bg-slate-800">
                  <img
                    src={ex.image}
                    alt={ex.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    decoding="async"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-950/20 to-transparent" />
                  <span className="absolute top-3 left-3 bg-amber-500 text-slate-950 text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">
                    {ex.tag}
                  </span>
                  <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between text-white">
                    <span className="inline-flex items-center gap-1.5 text-xs bg-slate-950/70 backdrop-blur px-2.5 py-1 rounded-full">
                      <Calendar className="w-3.5 h-3.5" /> {ex.duration}
                    </span>
                    <span className="inline-flex items-center gap-1.5 text-xs bg-slate-950/70 backdrop-blur px-2.5 py-1 rounded-full">
                      <Users className="w-3.5 h-3.5" /> max 19
                    </span>
                  </div>
                </div>

                <div className="p-6 flex flex-col flex-1">
                  <h3 className="text-xl font-semibold text-white">{ex.title}</h3>

                  <div className="mt-3 flex items-center gap-2 text-sm text-slate-400">
                    <MapPin className="w-4 h-4 text-amber-500" />
                    Plecare Mangalia · {ex.departure}
                  </div>

                  <ul className="mt-5 space-y-2 flex-1">
                    {ex.highlights.map((h) => (
                      <li key={h} className="flex items-start gap-2 text-sm text-slate-300">
                        <Star
                          className="w-4 h-4 text-amber-500 mt-0.5 shrink-0 fill-amber-500"
                          strokeWidth={1.8}
                        />
                        <span>{h}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="mt-6 pt-5 border-t border-slate-800 flex items-center justify-between">
                    <div>
                      <div className="text-xs text-slate-400 uppercase tracking-wider">De la</div>
                      <div className="text-lg font-bold text-white">{ex.price}</div>
                    </div>
                    <button
                      type="button"
                      onClick={() => handleReserve(ex.title)}
                      data-testid={`excursion-reserve-${ex.id}`}
                      className="inline-flex items-center gap-1.5 bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold rounded-full px-4 py-2 text-sm transition-all group-hover:translate-x-0.5"
                    >
                      Rezervă
                      <ArrowRight className="w-4 h-4" />
                    </button>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <div className="mt-14 text-center bg-gradient-to-br from-slate-900 to-slate-950 border border-slate-800 rounded-2xl p-8">
          <h3 className="text-xl lg:text-2xl font-bold text-white">
            Grupul tău vrea altă destinație?
          </h3>
          <p className="mt-3 text-slate-300 max-w-xl mx-auto">
            Organizăm excursii personalizate pentru grupuri de până la 19 persoane. Spune-ne unde
            vrei să ajungi și îți facem oferta.
          </p>
          <a
            href="#rezervare"
            data-testid="excursii-custom-cta"
            className="mt-6 inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold rounded-full px-6 py-3"
          >
            Solicită ofertă personalizată
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
